import { EnvironmentType } from '@/configs/environments/types'

export const config: EnvironmentType = {
  type: 'local',
  adisonOfwList: {
    baseUrl: 'https://api-ao-list-dev.adison.co/api'
  },
  adisonOfw: {
    baseUrl: 'https://api-ao-dev.adison.co/api'
  },
  adisonOfwGlobal: {
    baseUrl: 'https://api-ao-dev.g.adison.co/api'
  },
  firebase: {
    apiKey: 'AIzaSyCG3MTGNKwR8ptk70fdQGqEHkbdxsBbNns',
    authDomain: 'adison-offerwall-26c5e.firebaseapp.com',
    databaseURL: 'https://adison-offerwall-26c5e.firebaseio.com',
    projectId: 'adison-offerwall-26c5e',
    storageBucket: 'adison-offerwall-26c5e.appspot.com',
    messagingSenderId: '921460748260',
    appId: '1:921460748260:web:1b6ad1c322f5a8ca0321f1',
    measurementId: 'G-2K8W5LN5V7'
  }
}
